import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../commonFunctions";
  
  const responsibleofficermaster = {
    label: "Resposible Officer Master",
    starting: true,
    url: "responsibleofficermaster",
    pageLabel: "Resposible Officer Master",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            tab: "profile",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            label: "Resposible Officer",
            description: "Enter Resposible Officer"
          },
          {
            inputType: "text",
            tab: "profile",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "Resposible Officer",
            name: "ResponsibleOfficerEle",
            description: "Enter Resposible Officer"
          },        
    ],
    history: {
        perPage: 10,
        displayColumns: [
          {
            Header: "Resposible Officer",
            accessor: "ResponsibleOfficerEle",
          },
         
        ]
      },
    report: {
        perPage: 10,
        queryType: "mysqlQuery",
        //   groupBy: ["schedule","subschedule"],
        query: [
          {
            dialect: "mysql",
            seq: 1,
            columnHeader: [
              {
                id: "balance1",
                headerText: "trdate",
                headerFrom: "balance"
              }
            ],
            query: ""
          }
        ],
        displayColumns: [
          {
            Header: "Resposible Officer",
            accessor: "ResponsibleOfficerEle",
          },
          
        ]
      }
    
  };

export default responsibleofficermaster;